import React from "react";
import { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { Redirect } from "react-router";
import { Routes } from "../../../../constants/routes";
import Typography from "@material-ui/core/Typography";
import Loading from "../../../../components/Loading";
import { Field } from "react-final-form";
import { FormRenderProps } from "react-final-form";
import Button from "../../../../components/Button";
import BootstrapInput from "../../../../components/BootstrapInput";
import Hidden from "@material-ui/core/Hidden";
import { DesktopBlurredBackdrop } from "../BlurredBackdrop";
import BlurredBackdrop from "../BlurredBackdrop";
import FontIcon from "../../../../components/FontIcon";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
}));

const ForgotPasswordForm: FC<FormRenderProps> = ({
  form,
  values,
  submitting,
  submitError,
  handleSubmit,
  submitSucceeded,
}) => {
  const classes = useStyles();
  if (submitSucceeded) {
    return (
      <Redirect
        to={{
          pathname: `/${Routes.LOGIN}`,
          state: {
            message: {
              color: "inherit",
              text: "Your email for password reset was sent.",
            },
            email: values.email,
          },
        }}
      />
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      {submitError && <Typography color="error">{submitError}</Typography>}
      {submitting && <Loading />}
      <Typography component="div" className={classes.root}>
        <Typography component="div" className={classes.formControl}>
          <Field
            fullWidth
            type="text"
            name="email"
            label="Email"
            placeholder="Email"
            component={BootstrapInput}
          />
        </Typography>
        <Typography
          align="center"
          component="div"
          className={classes.formControl}
        >
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            fullWidth
            disabled={submitting}
          >
            Send
          </Button>
        </Typography>
      </Typography>
      {submitSucceeded && (
        <Hidden smDown>
          <DesktopBlurredBackdrop
            message="Check Your Mailbox."
            icon={<Plane />}
            actions={[
              {
                btnText: "OK",
                color: "secondary",
                variant: "contained",
                onClick: () => form.reset(values),
              },
            ]}
          />
        </Hidden>
      )}
      <Hidden mdUp>
        <BlurredBackdrop
          open={submitSucceeded}
          message="Check Your Mailbox."
          icon={<Plane />}
          actions={[
            {
              btnText: "OK",
              color: "secondary",
              variant: "contained",
              onClick: () => form.reset(values),
            },
          ]}
        />
      </Hidden>
    </form>
  );
};

function Plane() {
  return (
    <div
      style={{
        width: 110,
        height: 110,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "4px solid #e6c224",
      }}
    >
      <FontIcon color="secondary" style={{ fontSize: 40 }} name="plane" />
    </div>
  );
}

export default ForgotPasswordForm;
